"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsePanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_motion_1 = tslib_1.__importDefault(require("rc-motion"));
var ConfigProvider_1 = require("../ConfigProvider");
var icons_1 = require("../icons");
var hooks_1 = require("./hooks");
var utils_1 = require("../utils");
var motion_1 = tslib_1.__importDefault(require("./motion"));
function CollapsePanel(props) {
    var title = props.title, extra = props.extra, value = props.value, children = props.children, classNameFromProps = props.className, rootHtmlProps = props.rootHtmlProps, style = props.style;
    var prefix = ConfigProvider_1.usePrefix('collapse-panel');
    var activePrefix = utils_1.concat(prefix, 'active');
    var headerPrefix = utils_1.concat(prefix, 'header');
    var titlePrefix = utils_1.concat(headerPrefix, 'title');
    var titleWrapperPrefix = utils_1.concat(titlePrefix, 'wrapper');
    var iconPrefix = utils_1.concat(headerPrefix, 'icon');
    var extraPrefix = utils_1.concat(headerPrefix, 'extra');
    var bodyPrefix = utils_1.concat(prefix, 'body');
    var bodyWrapperPrefix = utils_1.concat(bodyPrefix, 'wrapper');
    var leavedPrefix = utils_1.concat(prefix, 'leaved');
    var motionPrefix = utils_1.concat(prefix, 'motion');
    var _a = hooks_1.useCollapse(), activeValue = _a.value, toggleActive = _a.toggleActive;
    var isExpanded = activeValue.indexOf(value) !== -1;
    var className = classnames_1.default(prefix, classNameFromProps, isExpanded && activePrefix, rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.className);
    var handleHeaderClick = react_1.useCallback(function () {
        // TODO 无边框和背景时改为点击name触发
        toggleActive(value);
    }, [toggleActive, value]);
    var handleExtraClick = react_1.useCallback(function (e) {
        e.stopPropagation();
    }, []);
    return (react_1.default.createElement("div", tslib_1.__assign({}, rootHtmlProps, { className: className, style: tslib_1.__assign(tslib_1.__assign({}, style), rootHtmlProps === null || rootHtmlProps === void 0 ? void 0 : rootHtmlProps.style) }),
        react_1.default.createElement("div", { className: headerPrefix, onClick: handleHeaderClick },
            react_1.default.createElement("div", { className: titleWrapperPrefix },
                react_1.default.createElement("div", { className: iconPrefix },
                    react_1.default.createElement(icons_1.RightThinIcon, null)),
                react_1.default.createElement("div", { className: titlePrefix }, title)),
            react_1.default.createElement("div", { className: extraPrefix, onClick: handleExtraClick }, extra)),
        react_1.default.createElement(rc_motion_1.default, tslib_1.__assign({ visible: isExpanded, leavedClassName: leavedPrefix, motionName: motionPrefix }, motion_1.default), function (_a, ref) {
            var motionClassName = _a.className, motionStyle = _a.style;
            return (react_1.default.createElement("div", { className: classnames_1.default(motionClassName, bodyWrapperPrefix), style: motionStyle, ref: ref },
                react_1.default.createElement("div", { className: bodyPrefix }, children)));
        })));
}
exports.CollapsePanel = CollapsePanel;
//# sourceMappingURL=Panel.js.map